"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Profile_container_1 = __importDefault(require("./Profile.container"));
exports.default = Profile_container_1.default;
//# sourceMappingURL=index.js.map